module.exports = __webpack_public_path__ + "static/img/app.7d1f3db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hsvccfg/app.png
// module id = 0wN8
// module chunks = 1